import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: .8rem;
    padding: .4rem 1rem .4rem 1rem;
`
export const ContainerInput = styled.div`
    width: 100%;
    height: 3.8rem;
`

export const CustomTextField = styled(TextFieldMui)`
    width: 100%; 
    margin: 0 !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`

export const ContainerButton = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1.4rem;
    width: 100%;
`
export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`
